import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import folderViewReducer from '../reducers/folderViewReducer';

const configureStore = (railsProps) => (
  createStore(folderViewReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
